import CreateHQLocation from "../pages/DCGAutomation/Pages/CreateHQLocation";
import CreateSubscription from "../pages/DCGAutomation/Pages/CreateSubscription";
import Level3Confirmation from "../pages/DCGAutomation/Pages/Level3Confirmation";
import PortalAdminInfo from "../pages/DCGAutomation/Pages/PortalAdminInfo";
import RequestPortalJoinCode from "../pages/DCGAutomation/Pages/RequestPortalJoinCode";
import SelectDeviceType from "../pages/DCGAutomation/Pages/SelectDeviceType";
import SelectRole from "../pages/DCGAutomation/Pages/SelectRole";
import SetStaffPermissions from "../pages/DCGAutomation/Pages/SetStaffPermissions";
import TraditionalDeviceConfirmation from "../pages/DCGAutomation/Pages/TraditionalDeviceConfirmation";
import SubscriptionConfirmation from "../pages/DCGAutomation/Pages/SubscriptionConfirmation";
import InviteRequestConfirmation from "../pages/DCGAutomation/Pages/InviteRequestConfirmation";
import SubscriptionConfirmationNoLicense from "../pages/DCGAutomation/Pages/SubscriptionConfirmationNoLicense";
import defaultRegionPage from "../pages/DCGAutomation/Pages/defaultRegionPage";
import PersonaAccountRegistrationPage from "../components/PersonaAccountRegistrationPage/PersonaAccountRegistrationPage";

// Sequence of pages for the new onboarding flow (DCG Automation)
export const automationPages = {
    selectRole: {
        prevPage: null, // Adjust accordingly
        page: SelectRole
    },
    defaultRegion: {
        prevPage: 'selectRole',
        page: defaultRegionPage
    },
    /*selectRole: {
        prevPage: null, // Adjust accordingly
        page: PortalAdminInfo
    },*/
    portalAdminInfo: {
        prevPage: 'defaultRegion',
        page: PortalAdminInfo
    },
    createHQLocation: {
        prevPage: 'portalAdminInfo',
        page: CreateHQLocation
    },
    setStaffPermissions: {
        prevPage: 'createHQLocation',
        page: SetStaffPermissions
    },
    level3Confirmation: {
        prevPage: 'setStaffPermissions',
        page: Level3Confirmation
    },
    personaAccountRegistrationPage: {
        prevPage: null,
        page: PersonaAccountRegistrationPage
    },
    selectDeviceType: {
        prevPage: 'setStaffPermissions',
        page: SelectDeviceType,
        needsAuth: true
    },
    createSubscription: {
        prevPage: 'selectDeviceType',
        page: CreateSubscription,
        needsAuth: true
    },
    confirmSubscription: {
        prevPage: 'createSubscription',
        page: SubscriptionConfirmation,
        finalConfirmation: true
    },
    traditionalDeviceConfirmation: {
        prevPage: 'subscriptionConfirmation',
        page: TraditionalDeviceConfirmation,
        finalConfirmation: true
    },
    requestPortalJoinCode: {
        prevPage: 'selectRole',
        page: RequestPortalJoinCode
    },
    inviteReqConfirmation: {
        page: InviteRequestConfirmation
    },
    // Persona authentication server expects a redirect URL with a formId 3
    3: {
        prevPage: 'setStaffPermissions',
        page: SelectDeviceType
    },
    subscriptionConfirmationNoLicense: {
        prevPage: null,
        page: SubscriptionConfirmationNoLicense,
        finalConfirmation: true
    }
};
